module.exports = __webpack_public_path__ + "img/poster-2.c5c7e5a0.png";